import { createReducer, on } from '@ngrx/store';

import { setPaginationData } from './pagination.actions';
import { initialState, PaginationState } from './pagination.state';

export const paginationReducer = createReducer(
  initialState,
  on(
    setPaginationData,
    (state, { pageNumber, pageSize }): PaginationState => ({
      ...state,
      pageNumber: pageNumber,
      pageSize: pageSize,
    })
  )
);
